var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 17,
  y: 33.6,
  fill: "none",
  width: 11.1,
  height: 2.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M38,33.6c1.1,0,1.9-0.8,2-1.9v-22c0-1.1-0.9-2-2-2H7c-1.1,0-2,0.9-2,2v22c0.1,1.1,0.9,1.9,2,1.9h8.6V36h-3 v1.3h19.2V36h-2.5v-2.4H38z M6.3,31.6V9.7C6.3,9.3,6.7,9,7,9h30.8c0.4,0,0.7,0.3,0.7,0.7v21.9c0,0.4-0.3,0.7-0.7,0.7H7 C6.7,32.3,6.3,32,6.3,31.6z M28,36H17v-2.4H28V36z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M37.8,32.3c0.4,0,0.7-0.3,0.7-0.7V9.7c0-0.4-0.3-0.7-0.7-0.7H7C6.7,9,6.3,9.3,6.3,9.7v21.9 c0,0.4,0.3,0.7,0.7,0.7H37.8z M12.3,13.9c0-0.4,0.3-0.7,0.7-0.7H32c0.4,0,0.7,0.3,0.7,0.7v13.6c0,0.4-0.3,0.7-0.7,0.7H13 c-0.4,0-0.7-0.3-0.7-0.7V13.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M13,28.2H32c0.4,0,0.7-0.3,0.7-0.7V13.9c0-0.4-0.3-0.7-0.7-0.7H13c-0.4,0-0.7,0.3-0.7,0.7v13.6 C12.3,27.9,12.6,28.2,13,28.2z M13.5,14.5h17.9v12.4H13.5V14.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M31.5,26.9V14.5H13.5v12.4H31.5z M19.8,16.7c0-0.3,0.2-0.5,0.4-0.6H21l5.2,4c0.2,0.2,0.3,0.4,0.3,0.6 c0,0.2-0.1,0.4-0.3,0.5l-5.2,4h-0.7c-0.2-0.1-0.4-0.3-0.4-0.5V16.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2724A",
  d: "M20.3,25.2H21l5.2-4c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2-0.1-0.4-0.3-0.6l-5.2-4h-0.7c-0.2,0.1-0.4,0.3-0.4,0.6 v8C19.9,24.9,20,25.1,20.3,25.2z"
}));

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.0ee174a3a2d87a109539a57c7848d581.svg";
export { ForwardRef as ReactComponent };